import { useMutation } from "react-query";
import saveOrgDraft from "../services/saveOrgDraft";

function useSaveOrgDraft(){
    return useMutation(["save-org-draft"], saveOrgDraft)
}

export default useSaveOrgDraft